import { createContext, useContext, useState } from "react";

const ConfirmModalContext = createContext();

export const ConfirmModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    confirmText: "Confirmer",
    cancelText: "Annuler",
    onConfirm: null,
    onCancel: null,
    variant: "default",
  });

  const openConfirmModal = ({
    title,
    message,
    confirmText = "Confirmer",
    cancelText = "Annuler",
    onConfirm,
    onCancel,
    variant= "default",
  }) => {
    setModal({
      isOpen: true,
      title,
      message,
      confirmText,
      cancelText,
      onConfirm,
      onCancel,
      variant,
    });
  };

  const closeModal = () =>
    setModal((prev) => ({ ...prev, isOpen: false }));

  return (
    <ConfirmModalContext.Provider
      value={{ modal, openConfirmModal, closeModal }}
    >
      {children}
    </ConfirmModalContext.Provider>
  );
};

export const useConfirmModal = () => useContext(ConfirmModalContext);